import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useState, useCallback} from 'react'
import {useHistory} from 'react-router-dom'

import {OrderIntakeSite} from '../types/OrderIntakeSite.types'

export const useJobSiteSelectionModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedJobSite, setSelectedJobSite] = useState<OrderIntakeSite | null>(null)
  const history = useHistory()

  const openModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsOpen(false)
    setSelectedJobSite(null)
  }, [])

  const handleJobSiteSelect = useCallback((jobSite: OrderIntakeSite) => {
    setSelectedJobSite(jobSite)
  }, [])

  const handleCreateNewOrder = useCallback(
    (jobSite: OrderIntakeSite) => {
      // Track job site selection event
      trackEvent('rmcJobSiteSelected', {
        jobSiteId: jobSite.siteId,
        customerId: jobSite.customerId,
        siteId: jobSite.siteId,
        businessLine: 'RMC'
      })

      // Navigate to RMC delivery page with selected job site data
      history.push(`/rmcDelivery?jobSiteId=${jobSite.siteId}`, {
        selectedJobSite: jobSite
      })
      closeModal()
    },
    [history, closeModal]
  )

  const handleRepeatPreviousOrder = useCallback(
    (jobSite: OrderIntakeSite) => {
      // Track repeat order event
      trackEvent('rmcRepeatOrderSelected', {
        jobSiteId: jobSite.siteId,
        customerId: jobSite.customerId,
        siteId: jobSite.siteId,
        businessLine: 'RMC'
      })

      // Navigate to RMC delivery page with job site data and repeat order flag
      history.push(`/rmcDelivery?jobSiteId=${jobSite.siteId}&repeatOrder=true`, {
        selectedJobSite: jobSite
      })
      closeModal()
    },
    [history, closeModal]
  )

  return {
    isOpen,
    selectedJobSite,
    openModal,
    closeModal,
    handleJobSiteSelect,
    handleCreateNewOrder,
    handleRepeatPreviousOrder
  }
}
